import { REACT_APP_API_URL, getCookie } from 'shared';
// Get - ProveAvail
export const getProveAvail = async () => {
    const cookie = getCookie('__rum_sid');
    return await fetch(`${REACT_APP_API_URL}identity/v1/prove/available`, {
        headers: {
            'Hyperdx-Session-Info': cookie,
            TestAutomation: getCookie('TestAutomation'),
        },
    });
};
export const newCreditApplication = async (location_id, language) => {
    const cookie = getCookie('__rum_sid');
    const queryParams = location_id
        ? `?location_id=${location_id}&language=${language}`
        : `?language=${language}`;
    return await fetch(`${REACT_APP_API_URL}consumer_applications/v1/prequalifications/new?${queryParams}`, {
        headers: {
            'Hyperdx-Session-Info': cookie,
            'X-Client-Page': window.location.href,
            TestAutomation: getCookie('TestAutomation'),
        },
    });
};
// Post - postProveSendAuthLink
export const postProveSendAuthLink = async ({ phone, ssn_last_4, credit_application_id, location_id, }) => {
    const hyperDxCookie = getCookie('__rum_sid');
    const testAutomationCookie = getCookie('TestAutomation');
    return await fetch(`${REACT_APP_API_URL}identity/v1/prove/send_auth_link`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Hyperdx-Session-Info': hyperDxCookie,
            TestAutomation: testAutomationCookie,
        },
        body: JSON.stringify({
            phone_number: phone,
            ssn_last_4,
            credit_application_id,
            location_id,
        }),
    });
};
// Post - postProveAuthLinkClicked
export const postProveAuthLinkClicked = async ({ vfp }) => {
    const cookie = getCookie('__rum_sid');
    return await fetch(`${REACT_APP_API_URL}identity/v1/prove/auth_link_clicked`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Hyperdx-Session-Info': cookie,
            TestAutomation: getCookie('TestAutomation'),
        },
        body: JSON.stringify({
            vfp,
        }),
    });
};
// Get - Status
export const getProveTransactionStatus = async (sessionJson) => {
    const cookie = getCookie('__rum_sid');
    if (Object.keys(sessionJson).length > 0) {
        return await fetch(`${REACT_APP_API_URL}identity/v1/prove/transaction_status?phone_number=${sessionJson.phone_number}&ssn_last_4=${sessionJson.ssn_last_4}&session_id=${sessionJson.session_id}`, {
            headers: {
                'Hyperdx-Session-Info': cookie,
                TestAutomation: getCookie('TestAutomation'),
            },
        });
    }
};
// Get - PreFillOTA
export const getProvePreFillOTA = async (sessionJson) => {
    const cookie = getCookie('__rum_sid');
    if (Object.keys(sessionJson).length > 0) {
        return await fetch(`${REACT_APP_API_URL}identity/v1/prove/pre_fill?phone_number=${sessionJson.phone_number}&credit_application_id=${sessionJson.credit_application_id}&date_of_birth=${sessionJson.date_of_birth}`, {
            headers: {
                'Hyperdx-Session-Info': cookie,
                TestAutomation: getCookie('TestAutomation'),
            },
        });
    }
};
// Get - PreFill
export const getProvePreFill = async (sessionJson) => {
    const cookie = getCookie('__rum_sid');
    if (Object.keys(sessionJson).length > 0) {
        return await fetch(`${REACT_APP_API_URL}identity/v1/prove/pre_fill?phone_number=${sessionJson.phone_number}&ssn_last_4=${sessionJson.ssn_last_4}&session_id=${sessionJson.session_id}`, {
            headers: {
                'Hyperdx-Session-Info': cookie,
                TestAutomation: getCookie('TestAutomation'),
            },
        });
    }
};
